var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{active: _vm.isLoaded}},[_c('div',{staticClass:"header"},[_c('RaceCounterComponent'),_c('RaceHeaderComponent')],1),_c('RaceBodyComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }